import { ReactNode } from 'react'

import s from './styles.module.scss'

interface Props {
  color: string
  bgColor: string
  children: ReactNode
}
export const TabsInfoAlert = ({ color, bgColor, children }: Props) => {
  return (
    <div
      className={s.tabsAlert}
      style={{ backgroundColor: bgColor, color }}
    >
      {children}
    </div>
  )
}
